import { useLingui as _useLingui } from "../../lib/i18n/useLingui";
import { Button } from "../../components/Button";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuPortal, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from "../../components/Dropdown";
import { ScrollArea, ScrollBar } from "../../components/ScrollArea";
import { DotsHorizontal } from "../../icons/v2-stroke";
import { cn } from "../../lib/utils";
import React, { useState } from "react";
const preventMenuItemClickThrough = event => {
  // With modal={false} the menu closes on pointer down; stop the click reaching what is behind it.
  event.preventDefault();
};
const renderSubmenuItem = (item, index, onItemClick) => /*#__PURE__*/React.createElement(DropdownMenuSub, {
  key: `${item.label}-${index}`
}, /*#__PURE__*/React.createElement(DropdownMenuSubTrigger, {
  label: item.label,
  disabled: item.disabled,
  onPointerDown: event => {
    event.stopPropagation();
  }
}), /*#__PURE__*/React.createElement(DropdownMenuPortal, null, /*#__PURE__*/React.createElement(DropdownMenuSubContent, null, item.selectionMode === "checkbox" ? item.items.map(subItem => /*#__PURE__*/React.createElement(DropdownMenuCheckboxItem, {
  key: subItem.id,
  label: subItem.name,
  description: subItem.description,
  checked: subItem.checked,
  onCheckedChange: checked => {
    if (!checked) {
      return;
    }
    item.onSelect(subItem.id);
    onItemClick === null || onItemClick === void 0 || onItemClick();
  },
  onSelect: event => {
    event.preventDefault();
  }
})) : /*#__PURE__*/React.createElement(ScrollArea, {
  className: "flex max-h-72 min-w-24 flex-col",
  hideScrollBar: true
}, item.items.map(subItem => /*#__PURE__*/React.createElement(DropdownMenuItem, {
  key: subItem.id,
  label: subItem.name,
  description: subItem.description,
  onPointerDown: preventMenuItemClickThrough,
  onClick: event => {
    event.stopPropagation();
    item.onSelect(subItem.id);
    onItemClick === null || onItemClick === void 0 || onItemClick();
  }
})), /*#__PURE__*/React.createElement(ScrollBar, {
  className: "py-0"
})))));
const renderRegularItem = (item, index, onItemClick) => {
  const {
    kind,
    ...itemProps
  } = item;
  return /*#__PURE__*/React.createElement(DropdownMenuItem, {
    key: `item-${index}`,
    ...itemProps,
    onPointerDown: preventMenuItemClickThrough,
    onClick: event => {
      var _itemProps$onClick;
      event.stopPropagation();
      (_itemProps$onClick = itemProps.onClick) === null || _itemProps$onClick === void 0 || _itemProps$onClick.call(itemProps, event);
      onItemClick === null || onItemClick === void 0 || onItemClick();
    }
  });
};
export const renderMenuItem = (item, index, onItemClick) => {
  switch (item.kind) {
    case "submenu":
      return renderSubmenuItem(item, index, onItemClick);
    case "item":
      return renderRegularItem(item, index, onItemClick);
  }
};
/** "..." row-actions button that opens a dropdown of menuItems. */
export function MoreButton({
  className,
  menuItems,
  dropdownMenuProps,
  disabled
}) {
  const {
    _: _t
  } = _useLingui();
  const [open, setOpen] = useState(false);
  if (!(menuItems !== null && menuItems !== void 0 && menuItems.length)) {
    return null;
  }
  const {
    onOpenChange: dropdownOnOpenChange,
    ...restDropdownMenuProps
  } = dropdownMenuProps !== null && dropdownMenuProps !== void 0 ? dropdownMenuProps : {};
  const closeMenu = () => {
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    open: open,
    onOpenChange: nextOpen => {
      setOpen(nextOpen);
      dropdownOnOpenChange === null || dropdownOnOpenChange === void 0 || dropdownOnOpenChange(nextOpen);
    },
    modal: false,
    ...restDropdownMenuProps
  }, /*#__PURE__*/React.createElement(DropdownMenuTrigger, {
    onClick: event => {
      event.stopPropagation();
    },
    onPointerDown: event => {
      event.stopPropagation();
    },
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, {
    icon: DotsHorizontal,
    "aria-label": _t(
    /** i18n */
    {
      id: "JcD7qf",
      message: "More actions"
    }),
    size: "icon",
    variant: "ghost-secondary",
    disabled: disabled,
    className: cn(disabled && "cursor-not-allowed opacity-50", className)
  })), /*#__PURE__*/React.createElement(DropdownMenuContent, {
    align: "end",
    hidden: disabled
  }, /*#__PURE__*/React.createElement(DropdownMenuGroup, null, menuItems.map((item, index) => renderMenuItem(item, index, closeMenu)))));
}
//# sourceMappingURL=menu.js.map